/** @returns The single element of the array or `undefined` if the array does not have exactly 1 element. */
export function singleElement<T>(array: T[] | undefined | null): T | undefined {
    return array?.length === 1 ? array[0] : undefined;
}
